export default __webpack_public_path__ + "static/media/success.e72ec338.png";